import React, {Component} from 'react';
import { findDOMNode } from 'react-dom'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Copyright from '../common/Copyright';
import Cookie from "../common/Cookie";
//import ReactPlayer from 'react-player'
import CircularProgress from "@material-ui/core/CircularProgress";
import CountOnline from './CountOnline';
import Slido from './Slido';
import Chat from './Chat';
import EventParams from "./EventParams";
import Banner from "./Banner";
import screenfull from 'screenfull';
import './css/main.css';
import Translation from "../common/Translation";
import Parameters from "../common/Parameters";

class Webinar extends Component {
    constructor() {
        super();
        this.params = new URLSearchParams(window.location.search);

        const initialState = EventParams.paramNames().reduce((obj, item) => {
            return {
                ...obj,
                [item]: '',
            };
        }, {error: ''});

        this.state = {
            ...initialState,
            id: '',
            eventId: 0,
            sendBtnText: ''
        };

        this.player = null;
        this.openFullScreen=this.openFullScreen.bind(this);
    }

    static get getSendButtonText() {
        return 'Отправить';
    }

    getBoxcastVideoUrl(boxcast_video_id) {
        let url = `https://boxcast.tv/view-embed/${boxcast_video_id}?showTitle=0&showDescription=0&showHighlights=0&showRelated=0&showCountdown=1&market=smb&showDocuments=0&showIndex=0&showDonations=0`;
        return this.state.google_video_params.trim().length > 0
            ? url + '&' + this.state.google_video_params
            : url;
        // <iframe width="720" height="800"
        //         src="https://boxcast.tv/view-embed/landlord-ua-zbrptcok0fafukrzdlu1?showTitle=0&showDescription=0&showHighlights=0&showRelated=0&showCountdown=1&market=smb&showDocuments=0&showIndex=0&showDonations=0"
        //         frameBorder="0" scrolling="auto" allowFullScreen="true" allow="autoplay; fullscreen"></iframe>
    }

    getGoogleVideoUrl(google_video_id) {
        // <iframe width="_BADGEWIDTH_" height="_BADGEHEIGHT_" src="https://www.youtube.com/embed/_GOOGLEVIDEOID_?rel=0&vq=hd720&showinfo=0&autoplay=1&playsinline=1&modestbranding=1_GOOGLEVIDEOPARAMS_" allow="autoplay; encrypted-media" frameborder="0"></iframe>
        return `https://www.youtube.com/embed/${google_video_id}?rel=0&showinfo=0&autoplay=1&playsinline=1&modestbranding=1&${this.state.google_video_params}`;
    }

    getVimeoUrl(vimeo_video_id) {
        return `https://player.vimeo.com/video/${vimeo_video_id}`;
    }

    getVideoPlayer() {
        if(this.state.video_provider === 'google') {
            return (
                <iframe width={'100%'} height={'100%'}
                        src={this.getGoogleVideoUrl(this.state.google_video_id)}
                        frameBorder={"0"} scrolling={"no"} allowFullScreen
                        allow={"autoplay; fullscreen; encrypted-media"}/>
            )


            // return (
            //     <ReactPlayer
            //         ref={this.ref}
            //         controls={true}
            //         url={this.getGoogleVideoUrl(this.state.google_video_id)}
            //         playing={true}
            //         width={'100%'}
            //         height={'100%'}
            //     />
            // );
        }

        if(this.state.video_provider === 'boxcast') {
            return (
                <iframe width={'100%'} height={'100%'}
                    src={this.getBoxcastVideoUrl(this.state.google_video_id)}
                    frameBorder={"0"} scrolling={"no"} allowFullScreen
                    allow={"autoplay; fullscreen"}/>
            )
        }

        if(this.state.video_provider === 'vimeo') {
            return (<iframe src={this.getVimeoUrl(this.state.google_video_id)} frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
                            style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}}/>);
        }

        return null;
    }

    setDefaultMessage() {
      this.setState({
        sendBtnText: Webinar.getSendButtonText
      });
    }

    componentDidMount() {
        let lang = this.params.get('lang');
        lang = !!lang ? lang : Cookie.get(Cookie.LANG);
        let id = this.params.get('id');
        id = !!id ? id : '';

        // id - user registration code
        EventParams.get(id, lang, (event) => {
            EventParams.paramNames().forEach((name) => {
                let state = this.state;
                state[name] = event.hasOwnProperty(name)
                    ? event[name]
                    : '';

                this.setState({
                    ...state,
                    id: id
                });
            });

        Translation.translate([Webinar.getSendButtonText], lang, (translation) => {
                this.setState({
                    sendBtnText: translation[Webinar.getSendButtonText],
                });
            }, () => {
                this.setDefaultMessage();
            }
        );

        }, (error) => {
            this.setState({error: error})
        })

    }

    // Define stream name by name of video_id
    detectStreamName(streamAttr) {
        let streams = Object.entries(this.state.streams);
        for (let s of streams) {
            if(s.length > 1
                && (s[0].trim() === streamAttr
                    || s[1].trim() === streamAttr)) {
                return s[0].trim();
            }
        }
        return streamAttr;
    }

    getQuizByStream(streamId) {

        let stream = this.detectStreamName(streamId);
        let quizList=this.state.quiz_id.split(',');
        let defaultQuizId = null;
        for (let quiz of quizList) {
            quiz = quiz.trim();
            let delimPos = quiz.indexOf(':');
            let url = quiz.substring(delimPos+1);
            let quizName = quiz.substring(0, delimPos)

            if(quizName === stream) {
                return url.trim();
            }

            defaultQuizId = !!defaultQuizId
                ? defaultQuizId
                : url.trim();
        }

        return !!defaultQuizId ? defaultQuizId : this.state.quiz_id;
    }

    switchStream(streamId) {
        if(streamId.substr(0,4).toLowerCase() === 'http') {
            let a = document.createElement('A');
            a.href = streamId;
            a.download = streamId.substr(streamId.lastIndexOf('/') + 1);
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }

        this.setState({
            ...this.state,
            google_video_id: streamId
        });
    }

    createStreamButtons() {
        if(!this.state.streams) {
            return null;
        }

        let arr = Object.entries(this.state.streams);
        if(arr.length < 2) {
            return null;
        }

        return arr.map((elem) => {
            return (<Button key={"btn-"+elem[0]} variant="outlined" color="primary" onClick={() => { this.switchStream(elem[1])}}><Typography style={{color:this.state.room_font_color}}>{elem[0]}</Typography></Button>);
        });
    }

    openFullScreen() {
        screenfull.request(findDOMNode(this.player))
    }

    ref = player => {
        this.player = player
    }

    render() {
        // http://localhost:3000/?lang=ua&p=remote&id=pF9eort9A1y2163SquYtrRogM0c317P0zlE3cUwuiu89EMzRuM
        // https://github.com/cookpete/react-player/blob/master/src/demo/App.js
        // https://www.npmjs.com/package/react-player
        if (this.state.error !== '') {
            let error = typeof this.state.error === 'string' ? this.state.error : 'Unexpected error';
            return (
                <Typography variant="h4" component="h4" gutterBottom>
                    {error}
                </Typography>
            );
        }

        if(this.state.is_after_event_quiz > 0) {
            const parameters = new Parameters();
            window.location.href = "/index.html?p=quiz&id="+parameters.getMemberId()+"&event_id="+parameters.getEventId();
            return '';
        }

        if (this.state.google_video_id === '') {
            return (<CircularProgress/>);
        }

        let streamButtons = this.state.streams
            ? this.createStreamButtons()
            : null;

        let videoStyle = {
            overflow: '',
            boxSizing: 'border-box',
            resize: 'horizontal',
            maxWidth: '100%',
            height: 0,
            paddingBottom: '56.25%',
            position: 'relative'
        };

        let wrapperStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '8px'
        };

        let buttonsWidth=streamButtons ? '20%' : '0%';
        let titleWidth=streamButtons ? '80%' : '100%';

        const isBackgroundPresent = typeof this.state.background_file !== 'undefined' && this.state.background_file.length > 8;
        const backgroundImage = isBackgroundPresent
            ? `url(${this.state.background_file})`
            : 'url(/images/0.jpg)';

        // TODO setInterval counter

        return (
            <div style={{
                backgroundImage: backgroundImage,
                color : !!this.state.room_font_color ? this.state.room_font_color : '#000000',
                width: '100%',
                height: '100%',
                justifyContent: 'flex-end',
                alignItems: 'center',
                position: 'relative',
                backgroundSize: 'cover'
            }}>

            <Grid container
                  direction="row"
                  justify="flex-start"
                  alignItems="flex-start"
                  style={{
                      fontFamily: 'Roboto',
                      fontWeight: 500
                  }}
            >
                <Grid
                    item
                    xl={10}
                    lg={10}
                    md={10}
                    sm={10}
                    xs={10}
                >
                    <div style={{width: titleWidth, float: 'left'}}><Typography id="webinar-title" variant="h6" component="h6" align="center">
                        {this.state.event_name}
                    </Typography></div>
                    <div style={{width: buttonsWidth, float: 'left', textAlign: 'right', height: '100%', padding: '8px'}}> {streamButtons}
                    {/*<IconButton onClick={this.openFullScreen}><FullScreenIcon fontSize={'large'} /></IconButton>*/}
                    </div>

                </Grid>

                <Grid
                    item
                    style={{
                        fontFamily: 'Roboto',
                        fontWeight: 500,
                        padding: '8px'
                    }}
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    xs={2}
                >
                    <div style={{textAlign: 'right', width: '100%'}}><CountOnline counterUrl={this.state.counterUrl} eventId={this.state.event_id}/></div>
                </Grid>


                <Grid
                    item
                    xl={8}
                    lg={8}
                    md={8}
                    sm={12}
                    xs={12}
                    id={"video-frame"}
                >
                    <div style={videoStyle}>
                        <div style={wrapperStyle}>
                            {this.getVideoPlayer(this.state.google_video_id)}
                        </div>
                    </div>
                </Grid>
                <Grid
                    item
                    style={{
                        padding: '8px',
                    }}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <Slido quizId={this.getQuizByStream(this.state.google_video_id)} isEnabled={this.state.is_quiz_enabled}/>
                    <Chat isEnabled={this.state.is_chat_enabled} sendBtnText={this.state.sendBtnText}/>
                </Grid>


                <Grid
                    item
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                >
                    <Banner src={this.state.banner_file} alt={this.state.event_name}/>
                </Grid>

                <Grid
                    item
                    style={{
                        padding: '8px'
                    }}
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                >
                    <Copyright/>
                </Grid>
            </Grid>
            </div>
        );
    }
}

export default Webinar;
